import React, { useEffect, useState } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { PricingSection } from './components/PricingSection';
import { ContactForm } from './components/ContactForm';
import { WhatsAppButton } from './components/WhatsAppButton';
import { Footer } from './components/Footer';
import { BrandBook } from './pages/BrandBook';
export function App() {
  const [showBrandBook, setShowBrandBook] = useState(false);
  useEffect(() => {
    const checkHash = () => {
      setShowBrandBook(window.location.hash === '#brand');
    };
    checkHash();
    window.addEventListener('hashchange', checkHash);
    return () => window.removeEventListener('hashchange', checkHash);
  }, []);
  if (showBrandBook) {
    return <BrandBook data-id="element-0" />;
  }
  return <div className="min-h-screen bg-white selection:bg-blue-100 selection:text-blue-900" data-id="element-1">
      <Navbar data-id="element-2" />

      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <SolutionSection data-id="element-6" />
        <HowItWorksSection data-id="element-7" />
        <PricingSection data-id="element-8" />
        <ContactForm data-id="element-9" />
      </main>

      <Footer data-id="element-10" />
      <WhatsAppButton data-id="element-11" />
    </div>;
}